module.exports = __webpack_public_path__ + "static/img/NSW-24.cbcc516.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-24.jpg
// module id = aU59
// module chunks = 0